/* eslint-disable */ 
jQuery(".Dropdown-title").click(function () {
jQuery('.Dropdown').find('.Dropdown-content').not(jQuery(this).next()).slideUp(300);
jQuery('.active').not(this).removeClass('active');

jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle(300);
});
